











import Vue, { PropType } from "vue"
import { vueWith } from "./../vueWith"

/**
 * @example
 *  <year-component
 *    v-model="year"
 *    class="select"
 *    v-bind:class="{ none: radio == 1 || frequency != 1 }"
 *  ></year-component>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    value: String,
    options: Array as PropType<number[]>,
  },
  data() {
    return {
      // value: "1",
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    //
  },

  methods: {

    updateValue(e: any) {
      this.$emit("input", e.target!.value)
    },

    // 子から呼ばれる ---------------------------------------------

  },
})


